"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RudderStack = void 0;
var analytics_js_1 = require("@rudderstack/analytics-js");
var RudderStack = /** @class */ (function () {
    function RudderStack(RUDDERSTACK_KEY) {
        var _this = this;
        this.analytics = new analytics_js_1.RudderAnalytics();
        this.has_identified = false;
        this.has_initialized = false;
        this.current_page = '';
        /**
         * @returns The anonymous ID assigned to the user before the identify event was called
         */
        this.getAnonymousId = function () { return _this.analytics.getAnonymousId(); };
        /**
         * @returns The user ID that was assigned to the user after calling identify event
         */
        this.getUserId = function () { return _this.analytics.getUserId(); };
        /**
         * Initializes the Rudderstack SDK. Ensure that the appropriate environment variables are set before this is called.
         * For local/staging environment, ensure that `RUDDERSTACK_STAGING_KEY` and `RUDDERSTACK_URL` is set.
         * For production environment, ensure that `RUDDERSTACK_PRODUCTION_KEY` and `RUDDERSTACK_URL` is set.
         */
        this.init = function (RUDDERSTACK_KEY) {
            if (RUDDERSTACK_KEY) {
                _this.analytics.load(RUDDERSTACK_KEY, 'https://deriv-dataplane.rudderstack.com');
                _this.analytics.ready(function () {
                    _this.has_initialized = true;
                    _this.has_identified = !!(_this.getUserId() || !!_this.getAnonymousId());
                });
            }
        };
        /**
         *
         * @param user_id The user ID of the user to identify and associate all events with that particular user ID
         * @param payload Additional information passed to identify the user
         */
        this.identifyEvent = function (user_id, payload) {
            _this.analytics.identify(user_id, payload);
            _this.has_identified = true;
        };
        /**
         * Pushes page view event to Rudderstack
         *
         * @param curret_page The name or URL of the current page to track the page view event
         */
        this.pageView = function (current_page, platform, user_id) {
            if (platform === void 0) { platform = 'Deriv App'; }
            if (_this.has_initialized && _this.has_identified && current_page !== _this.current_page) {
                _this.analytics.page(platform, current_page, { user_id: user_id });
                _this.current_page = current_page;
            }
        };
        /**
         * Pushes reset event to rudderstack
         */
        this.reset = function () {
            if (_this.has_initialized) {
                _this.analytics.reset();
                _this.has_identified = false;
            }
        };
        /**
         * Pushes track events to Rudderstack. When this method is called before `identifyEvent` method is called, the events tracked will be associated with an anonymous ID.
         * Otherwise, if the events needs to be associated with a user ID, call `identifyEvent` with the user ID passed first before calling this method.
         *
         * @param event The event name to track
         * @param payload Additional information related to the event
         */
        this.track = function (event, payload) {
            var clean_payload = Object.fromEntries(Object.entries(payload).filter(function (_a) {
                var _ = _a[0], value = _a[1];
                return value !== undefined;
            }));
            if (_this.has_initialized && _this.has_identified) {
                try {
                    _this.analytics.track(event, clean_payload);
                }
                catch (err) {
                    console.error(err);
                }
            }
        };
        this.init(RUDDERSTACK_KEY);
    }
    RudderStack.getRudderStackInstance = function (RUDDERSTACK_KEY) {
        if (!RudderStack._instance) {
            RudderStack._instance = new RudderStack(RUDDERSTACK_KEY);
            return RudderStack._instance;
        }
        return RudderStack._instance;
    };
    return RudderStack;
}());
exports.RudderStack = RudderStack;
